import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { AccountService } from 'app/core';
import { AggregatedTasksService } from '../aggregated-tasks/aggregated-tasks.service';
import { ContactsService } from './contacts.service';
import { Contact, Country, Category } from './contacts.types';
import { Store } from '@ngxs/store';
import { SetEthanContext } from '@state/ethan/ethan.action';
import { RelatedToType } from '@shared/enums';
import { AccountState } from '@state/account/state';

@Injectable({
  providedIn: 'root',
})
export class ContactByIdResolver {
  constructor(
    private _router: Router,
    private _contactsService: ContactsService,
    private _accountService: AccountService,
    private readonly store: Store,
  ) {
    this._accountService.currentAccount.subscribe((accountData) => {
      this._contactsService.accountId = accountData.id;
    });
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Contact> {
    return this._contactsService.getContactById(route.paramMap.get('id')).pipe(
      tap((contact) => {
        this.store.dispatch(new SetEthanContext(contact, RelatedToType.Contact));
      }),
      // Error here means the requested contact is not available
      catchError((error) => {
        // Log the error
        console.error(error);

        // Get the parent url
        const parentUrl = state.url.split('/').slice(0, -1).join('/');

        // Navigate to there
        this._router.navigateByUrl(parentUrl);

        // Throw an error
        return throwError(error);
      }),
    );
  }
}

@Injectable({
  providedIn: 'root',
})
export class ContactsCategoriesResolver {
  constructor(private _accountService: AccountService) {}

  resolve(): Observable<Category[]> {
    return this._accountService.getCategories();
  }
}

@Injectable({
  providedIn: 'root',
})
export class ContactsCountriesResolver {
  constructor(private _contactsService: ContactsService) {}

  resolve(): Observable<Country[]> {
    return this._contactsService.getCountries();
  }
}

@Injectable({
  providedIn: 'root',
})
export class ContactTaskResolver {
  constructor(
    private _router: Router,
    private _aggregatedTasksService: AggregatedTasksService,
    private readonly store: Store,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    this._aggregatedTasksService.accountId = this.store.selectSnapshot(AccountState.getAccount).id;
    return this._aggregatedTasksService
      .getTaskById(+route.paramMap.get('task_list_id'), +route.paramMap.get('task_id'))
      .pipe(
        // Error here means the requested task is not available
        catchError((error) => {
          // Log the error
          console.error(error);

          // Get the parent url
          const parentUrl = state.url.split('/').slice(0, -1).join('/');

          // Navigate to there
          this._router.navigateByUrl(parentUrl);

          // Throw an error
          return throwError(error);
        }),
      );
  }
}
